import React from 'react'
import { connect } from 'react-redux'

import Component from '../components/appointments'
import actions from '../actions/appointments'
import missingInfoActions from '../../missingInfo/actions/missingInfo'

class Container extends React.Component {

  constructor(props) {
    super(props)

    props.fetch()
  }

  render() {
    return <Component {...this.props} />
  }

  static propTypes = {}
}

const mapStateToProps = state => {
  const data = state.ui.activity.appointments
  return {
    transaction: data.get('transaction'),
    transactions: data.get('transactions'),
    openCancelDialog: data.get('openCancelDialog'),
    openViewDialog: data.get('openViewDialog'),
    isLoading: data.get('isLoading'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetch: () => dispatch(actions.fetch()),
    fetchTransaction: (transactionID) => dispatch(actions.fetchTransaction(transactionID)),
    startDeposit: () => dispatch(missingInfoActions.start('deposit')),
    selectTransaction: transaction => dispatch(actions.selectTransaction(transaction)),
    cancelAppointment: () => dispatch(actions.cancelAppointment()),
    setCancelDialogOpen: open => dispatch(actions.setCancelDialogOpen(open)),
    setViewDialogOpen: open => dispatch(actions.setViewDialogOpen(open)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/activity/containers/appointments.js